<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-analysis-table-4';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.task-analysis-table-4 {
  --header-cell-height: 50px;
  --body-cell-height: 45px;
  thead {
    tr {
      border-top: 3pt solid var(--theme-color-1);
    }
  }
  tbody {
    tr {
      border-top: 3pt solid var(--theme-color-1);
      &:last-child {
        border-bottom: 3pt solid var(--theme-color-1);
      }
    }
  }
}
</style>
